import {ReactComponent as ErrorIcon} from '../../assets/icons/error.svg'

export const NotFoundPage = () => {
    return <div className="container py-8 text-center not-found-page">
        <ErrorIcon />
        <h1 className="big-living-typo my-4">Page not found</h1>
        <p>This Media Center Page is not available. You may have an incorrect link or the Media Center will no longer be available.</p>
    </div>
}
